import { ITextStyles } from '@fluentui/react';

export const titleStyles: ITextStyles = {
  root: {
    fontWeight: 600,
    margin: '10px 0',
  },
};
